// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetCategoryService = {};
// console.log("🚀 ~ AssetCategoryService:", AssetCategoryService);

AssetCategoryService.postAssetCategory = function (data) {
  return lossClient({
    url: "/assetCategory/add",
    method: "post",
    data: data,
  });
};

AssetCategoryService.getAssetCategoryList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  // console.log(
  //   "🚀 ~ file: AssetCategoryService.js:17 ~ userInputIndex:",
  //   userInputIndex
  // );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: AssetCategoryService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/AssetCategory/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

AssetCategoryService.getAssetCategoryApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex;
  // console.log(
  //   "🚀 ~ file: AssetCategoryService.js:45 ~ userInputIndex:",
  //   userInputIndex
  // );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: AssetCategoryService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/AssetCategory/approvalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

AssetCategoryService.putAssetCategoryApproval = function (data) {
  const requestDataValidation =
    data.approvalFlag.toLowerCase() == "return"
      ? { userId: data.userId, Note: data.note, CategoryAssetId: data.id }
      : data.approvalFlag.toLowerCase() == "reject"
      ? { UserId: data.userId, Note: data.note, CategoryAssetId: data.id }
      : data.approvalFlag == "approve"
      ? { userId: data.userId, Note: data.note, CategoryAssetId: data.id }
      : { userId: data.userId, Note: data.note, CategoryAssetId: data.id };

  let urlRequest;
  const requestUrlValdiation =
    data.approvalFlag.toLowerCase() == "return"
      ? (urlRequest = "return")
      : data.approvalFlag.toLowerCase() == "reject"
      ? (urlRequest = "reject")
      : data.approvalFlag == "approve"
      ? (urlRequest = "approve")
      : (urlRequest = "");

  // console.log("🚀 ~ data:", data);
  // console.log("🚀 ~ urlRequest:", urlRequest);
  // console.log("🚀 ~ requestUrlValdiation:", requestUrlValdiation);
  // console.log("🚀 ~ validData:", requestDataValidation);

  return lossClient({
    url: `/assetCategory/${urlRequest}`,
    method: "put",
    headers: {
      "x-requestid": data.assetTypeId,
    },
    data: requestDataValidation,
  });
};

AssetCategoryService.putAssetCategoryRequest = function (data) {
  // console.log("🚀 ~ data:", data);

  var bodyRequest = {
    CategoryAssetId: data.CategoryAssetId,
    Request: data.Request,
    note: data.note,
    userId: data.userId,
  };
  // console.log("🚀 ~ bodyRequest:", bodyRequest);
  return lossClient({
    url: `/assetCategory/${data.approvalFlag}`,
    method: "put",
    headers: {
      "x-requestid": data.AssetTypeId,
    },
    data: bodyRequest,
  });
};

AssetCategoryService.getAssetCategoryDetail = function (data) {
  return lossClient({
    url: `/assetCategory/${data.id}`,
    method: "get",
  });
};

AssetCategoryService.updateAssetCategory = function (data) {
  // console.log("🚀 ~ data:", data);
  const { AssetId, ...requestBody } = data;
  // console.log("🚀 ~ rest:", requestBody);

  return lossClient({
    url: "/assetCategory/Edit",
    method: "put",
    headers: {
      "x-requestId": data.AssetId,
    },
    data: requestBody,
  });
};

AssetCategoryService.deleteAssetCategory = function (data) {
  // console.log("🚀 ~ AssetCategoryService.deleteAssetCategory ~ data:", data);
  const { AssetTypeId, ...requestBody } = data;
  // console.log("🚀 ~ requestBody:", requestBody);
  return lossClient({
    url: "/assetCategory/Delete",
    method: "delete",
    headers: {
      "x-requestid": data.AssetTypeId,
    },
    data: requestBody,
  });
};

export default AssetCategoryService;
